"use client";
import { useEffect, useState } from "react";
import CryptoDashboard from "./crypto-dashboard";
import { PerformanceChart } from "./performance-chart";
import { PortfolioSummary } from "./portfolio-summary";
import TradingInterface from "./trading-interface";
import { useAuth } from "../context/AuthContext";
import { usePortfolioEstimate } from "../context/PortfolioEstimateContext";
import { TradingProvider } from "../context/TradingContext";
import { CurrencySelectionProvider } from "../context/CurrencySelectionContext";
import Toaster from "../components/ui/toaster";
import DashboardCarousel from "./DashboardCarousel";

const DashboardContent = () => {
  const { user } = useAuth();
  const [firstTimeUser, setFirstTimeUser] = useState(true);
  const { portfolioData, isLoading: loading } = usePortfolioEstimate();
  useEffect(() => {
    if (portfolioData?.portfolioEstimateRaw > 0) {
      setFirstTimeUser(false);
    }
  }, [portfolioData]);

  return (
    <main>
      <Toaster />
      <CurrencySelectionProvider>
        <div className="-mt-4 rounded-t-2xl px-4 py-5 md:px-14 md:py-8 bg-[#f8f8f8] min-h-96 md:rounded-none">
          <PortfolioSummary />
          <>
            <div className="flex justify-between mb-4 gap-3 md:mb-5 md:gap-4 flex-wrap md:flex-nowrap overflow-hidden">
              <div className="md:bg-card md:rounded-lg md:border flex flex-col min-h-[280px] md:min-h-[500px] w-full md:w-[57%] overflow-hidden">
                {!firstTimeUser && portfolioData ? (
                  <PerformanceChart
                    userId={user?.user_id}
                    allStartDate={user?.createdAt}
                    loading={loading}
                  />
                ) : (
                  <DashboardCarousel />
                )}
              </div>
              <div className="bg-card rounded-lg border w-full md:w-[43%] overflow-hidden">
                <TradingProvider>
                  <TradingInterface />
                </TradingProvider>
              </div>
            </div>
            <CryptoDashboard />
          </>
        </div>
      </CurrencySelectionProvider>
    </main>
  );
};

export default DashboardContent;
